export const ROLES = "ROLES";
export const USERS = "USERS";
export const LOCATIONS = "LOCATIONS";
export const USER_ROLE = "USER_ROLE";
